module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "disclaimer"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.data.body)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-011303ae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/block/BlockDisclaimer.vue
// module id = 649
// module chunks = 0